function f(e) {
  "@babel/helpers - typeof";
  return f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f(e);
}
function m(e, t) {
  return G(e) || _(e, t) || X(e, t) || I();
}
function I() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X(e, t) {
  if (e) {
    if (typeof e == "string") return E(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return E(e, t);
  }
}
function E(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, u, a, l, i = [], o = !0, s = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        o = !1;
      } else for (; !(o = (r = a.call(n)).done) && (i.push(r.value), i.length !== t); o = !0) ;
    } catch (v) {
      s = !0, u = v;
    } finally {
      try {
        if (!o && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (s) throw u;
      }
    }
    return i;
  }
}
function G(e) {
  if (Array.isArray(e)) return e;
}
function z(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, H(r.key), r);
  }
}
function Z(e, t, n) {
  return t && x(e.prototype, t), n && x(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function H(e) {
  var t = R(e, "string");
  return f(t) == "symbol" ? t : t + "";
}
function R(e, t) {
  if (f(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (f(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var A = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, g = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, L = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, U = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, j = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, $ = Object.keys(j), c = "NaN";
function F(e, t) {
  return e * j[t];
}
var y = /* @__PURE__ */ function() {
  function e(t, n) {
    z(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !L.test(n) && (this.num = NaN, this.unit = ""), $.includes(n) && (this.num = F(t, n), this.unit = "px");
  }
  return Z(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, u = (r = U.exec(n)) !== null && r !== void 0 ? r : [], a = m(u, 3), l = a[1], i = a[2];
      return new e(parseFloat(l), i ?? "");
    }
  }]);
}();
function T(e) {
  if (e.includes(c))
    return c;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = A.exec(t)) !== null && n !== void 0 ? n : [], u = m(r, 4), a = u[1], l = u[2], i = u[3], o = y.parse(a ?? ""), s = y.parse(i ?? ""), v = l === "*" ? o.multiply(s) : o.divide(s);
    if (v.isNaN())
      return c;
    t = t.replace(A, v.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var b, P = (b = g.exec(t)) !== null && b !== void 0 ? b : [], d = m(P, 4), p = d[1], C = d[2], h = d[3], N = y.parse(p ?? ""), S = y.parse(h ?? ""), w = C === "+" ? N.add(S) : N.subtract(S);
    if (w.isNaN())
      return c;
    t = t.replace(g, w.toString());
  }
  return t;
}
var k = /\(([^()]*)\)/;
function M(e) {
  for (var t = e; t.includes("("); ) {
    var n = k.exec(t), r = m(n, 2), u = r[1];
    t = t.replace(k, T(u));
  }
  return t;
}
function Q(e) {
  var t = e.replace(/\s+/g, "");
  return t = M(t), t = T(t), t;
}
function K(e) {
  try {
    return Q(e);
  } catch {
    return c;
  }
}
function W(e) {
  var t = K(e.slice(5, -1));
  return t === c ? "" : t;
}
export {
  W as reduceCSSCalc,
  K as safeEvaluateExpression
};
